import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CircularProgress from '@mui/material/CircularProgress';
import { StyleConstants, Styles } from '../Styles';
import PaginationComponent from './PaginationComponent';
import { Stack } from '@mui/material';

const TablePaginationComponent = (props) => {
    const { isLoading, columns, rows, rowsPerPage, page, onChange } = props;

    return (
        <>
            {isLoading && (
                <Box sx={{ flexGrow: 1, textAlign: 'center' }}>
                    <CircularProgress />
                </Box>
            )}
            {!isLoading && (
                <>
                    <Stack direction="column" sx={{ width: '100%', height: '100%' }}>
                        <TableContainer component={Paper} sx={{ width: '100%', height: 'calc(100% - 40px)' }}>
                            <Table size="small">
                                <TableHead sx={{ backgroundColor: StyleConstants.componentBgColor }}>
                                    <TableRow>
                                        {columns.map((column) => (
                                            <TableCell
                                                key={column.id + '-header'}
                                                align={column.align}
                                                className="table-head-cell"
                                                sx={{ ...Styles.tableHeader, minWidth: column.width, width: column.width }}
                                            >
                                                {column.label}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows
                                        .slice((page - 1) * rowsPerPage, rowsPerPage === -1 ? undefined : ((page - 1) * rowsPerPage + rowsPerPage))
                                        .map((row, index) => {
                                            return (
                                                <TableRow hover key={row.seq + '-' + index} role="checkbox" tabIndex={-1}>
                                                    {columns.map((column) => {
                                                        const value = row[column.id];
                                                        return (
                                                            <TableCell sx={Styles.tableCell} key={column.id + '-' + index} align={column.align}>
                                                                {column.format ? column.format(value, row) : value}
                                                            </TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            );
                                        }
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Box sx={{ height: '40px', alignContent: 'center', textAlign: 'center', color: Styles.fontColor }}>
                            {rows && (rows.length > 0) && (
                                <PaginationComponent
                                    count={Math.ceil(rows.length / rowsPerPage)}
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    onChange={onChange}
                                />
                            )}
                        </Box>
                    </Stack>
                </>
            )}
        </>
    );
};

export default TablePaginationComponent;